module.exports = __webpack_public_path__ + "images/category_lp/art_work/new/assessment_achievements/1_83baa88aafacd33fc2008f0d00984a45.png";